import React, { useState, useEffect, useMemo, useRef } from "react";
import { useLocation } from "react-router-dom";
import useCustomNavigate from "../../common_nextgen/common_components/Navigation/NextGenNavigation";
import Form from "../../common_nextgen/common_components/form/Form";
import {
  PRICE_SCHEDULE_MODES,
  isAddMode,
  isEditMode,
  isReadOnlyMode,
} from "../../common_nextgen/utils/Constants";
import { useAxios } from "../../common_nextgen/axios/AxiosHelper";
import { useToast } from "../../common_nextgen/hooks/ToastContext";
import FunctionKeys from "../../common_nextgen/common_components/FunctionKeys/FunctionKeys";
import { formFields } from "./OutOfPocketCopyConfig";
import { screenInfo } from "./OutOfPocketCopyConfig";
import { ROUTE_PATHS } from "../../common_nextgen/utils/Constants";

const CopyOutOfPocketMaxSchedule = ({ mode }) => {
  const location = useLocation();
  const { axios_helper_no_header } = useAxios();
  const { OUT_OF_POCKET_MAX_SCHEDULE } = ROUTE_PATHS;
  //const { selectedPriceSchedules = [{opcScheduleName:"SCHED1",opcDescription:"Description 1"},{opcScheduleName:"SCHED2",opcDescription:"Description 2"}], previousScreen = '/out-of-pocket-schedule', currentIndex: initialIndex = 0 } = location.state || {};
  const { state: stateVal } = location;
  const [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);
  const {
    selectedSchedules = [],
    previousScreen = OUT_OF_POCKET_MAX_SCHEDULE,
    currentIndex: initialIndex = 0,
  } = currentState;
  const navigateToPage = useCustomNavigate();
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [currentMode, setCurrentMode] = useState(mode);
  //   const [initialFormData, setInitialFormData] = useState({});
  const [constraintErrors, setConstraintErrors] = useState([]);
  const toast = useToast();

  const lastValidOpcScheduleName = useRef("");

  const initialFormData = useMemo(() => {
    const {
      opcScheduleName: parDscScheduleName = "",
      opcDescription: parDscDescription = "",
      dtlDscScheduleName = "",
      dtlDscDescription = "",
    } = selectedSchedules[currentIndex];
    return {
      parDscScheduleName,
      parDscDescription,
      dtlDscScheduleName,
      dtlDscDescription,
    };
  }, [selectedSchedules, currentIndex]);
  const handleBack = () => {
    const lastScheduleName =
      selectedSchedules[currentIndex]?.dtlDscScheduleName;
    if (lastScheduleName) {
      lastValidOpcScheduleName.current = lastScheduleName;
    }
    if (currentIndex < selectedSchedules.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      const lastRecord = previousState.pop() ?? {};
      const updatedLastRecord = lastValidOpcScheduleName.current
        ? {
            ...lastRecord,
            paramsData: {
              opcScheduleName: lastValidOpcScheduleName.current,
              hiddenRecordIndicator: "Active",
            },
          }
        : lastRecord;
      const updatedPreviousState = [...previousState, updatedLastRecord];
      navigateToPage(previousScreen, updatedPreviousState);
    }
  };

  const getPageTitle = () => {
    const { SCREEN_TITLE, SCREEN_NUMBER } = screenInfo;
    return (
      <>
        <span className="title">{SCREEN_TITLE}</span>
        <span>{"-"}</span>
        <span className="screen-number">{SCREEN_NUMBER}</span>
      </>
    );
  };

  const submitForm = async (dataForSubmission) => {
    const data = {
      ...dataForSubmission,
      screenNumber: screenInfo.SCREEN_NUMBER,
    };
    const url = "api/opcOutPoktMaxSchCtrl/copy";
    const verb = "POST";

    try {
      const { responseStatus } = await axios_helper_no_header(
        verb,
        url,
        data,
        null
      );
      toast.current.show({
        severity: "success",
        summary: "",
        detail: responseStatus.message,
        life: 3000,
      });
      selectedSchedules[currentIndex].dtlDscScheduleName =
        data.dtlDscScheduleName;
      selectedSchedules[currentIndex].dtlDscDescription =
        data.dtlDscDescription;
    } catch (error) {
      const {
        responseStatus: { displayErrorFields = null, message },
      } = error.data;
      if (displayErrorFields === null) {
        toast.current.show({
          severity: "error",
          summary: "",
          detail: message,
          life: 3000,
        });
      } else {
        setConstraintErrors(displayErrorFields);
      }
    }
  };

  const [keyFunc, keyName] = useMemo(() => {
    const keys = [{ key: "F12", name: "Back", func: handleBack }];

    const keyFunc = {};
    const keyName = {};

    keys.forEach(({ key, name, func }) => {
      keyFunc[key] = func;
      keyName[key] = name;
    });

    return [keyFunc, keyName];
  }, [currentIndex]);

  //   useEffect(() => {
  //     const fetchInitialData = async () => {
  //       const url = `api/priceschedule/${selectedPriceSchedules[currentIndex]}`;
  //       try {
  //         const { responseData } = await axios_helper_no_header('GET', url, null, null);
  //         setInitialFormData(responseData);
  //       } catch (error) {
  //         const { responseStatus: { message } } = error.data;
  //         toast.current.show({ severity: "error", summary: "", detail: message, life: 3000 });
  //       }
  //     };

  //     fetchInitialData();
  //   }, [currentIndex]);

  return (
    <div className="grid container">
      <div className="col col-12">
        <FunctionKeys keyFunc={keyFunc} keyName={keyName} />
      </div>
      <div className="col col-12">
        <h1>{getPageTitle()}</h1>
      </div>
      <div className="col col-12">
        <Form
          formData={initialFormData}
          formFields={formFields}
          mode={mode}
          submitFormData={submitForm}
          constraintErrors={constraintErrors}
        />
      </div>
    </div>
  );
};

export default CopyOutOfPocketMaxSchedule;
